<div class="container-fluid">
  <div class="row text-center align-items-center heroSectionBg">
    <div class="col-md-12 customGapping mobileViewPadding">
      <h5 class="font40 font600 text-white">
        Discover great places in {{ location }}
      </h5>
      <form autocomplete="off">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Keywords"
              checked="true"
            />
            &nbsp;<span class="text-white align-middle me-4">Keywords</span>
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Business"
            />
            &nbsp;<span class="text-white align-middle me-4"
              >Business Name</span
            >
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Bizspot"
            />
            &nbsp;<span class="text-white align-middle me-4">Bizspot</span>
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Keywords"
            />
            &nbsp;<span class="text-white align-middle me-4">Collections</span>
          </div>
          <div class="col-md-8 mt-3">
            <div class="input-group">
              <span
                class="input-group-text lightDarkPurple border-end-0 dropdown"
              >
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
                  class="img-fluid"
                  alt="location-icon"
                />
                <span class="font16 font500 ms-1 styled-select">
                  <input
                    class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                    list="datalistOptions2"
                    placeholder="Type to search..."
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="searchText"
                    [(ngModel)]="searchText"
                    (keyup)="getNearBy()"
                    (focus)="getNearBy()"
                  />
                  <ul
                    class="dropdown-menu p-3 searchDropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li class="lightDarkPurple p-2 rounded customPurple">
                      <img
                        class="img-fluid"
                        src="../../../../assets/instaciti-new-img/Group 17.svg"
                        alt="location"
                      />
                      <span class="locationText cursorPointer ms-2" (click)="setCurrentLocation()"
                        >Detect current location</span
                      >
                    </li>
                    <ng-container>
                      <p class="font18 font500 customPurple mt-3">
                        Popular cities
                      </p>
                      <ng-container *ngFor="let city of popularCities">
                        <li>
                          <a
                            class="dropdown-item"
                            (click)="selectPopularCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{ city.CityName }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="searchText">
                      <p class="font18 font500 customPurple mt-3">
                        Nearby Location
                      </p>
                      <ng-container *ngFor="let city of nearby">
                        <li>
                          <a
                            class="dropdown-item"
                            (click)="selectNearByCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{ city.LocName }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                  </ul>
                </span>
              </span>
              <input
                class="form-control customInput p-3 border-start-0 border-end-0"
                placeholder="Type to search..."
                (keyup)="search($event)"
                (focus)="search($event)"
                [matAutocomplete]="keywords"
                [(ngModel)]="selectedKeyWord.Keywd"
                [ngModelOptions]="{standalone: true}"
              />
              <mat-autocomplete
                #keywords="matAutocomplete"
                (optionSelected)="onChange($event.option.value)"
              >
                <mat-option *ngFor="let item of searchResult" [value]="item">
                  {{ item.Keywd }}
                </mat-option>
              </mat-autocomplete>
              <span class="input-group-text bg-white border-start-0"
                ><img
                  src="../../../../assets/instaciti-new-img/Vector (5).svg"
                  alt="location-icon"
              /></span>
            </div>
            <div *ngIf="false" class="dropdown w-100 mt-2">
              <input
                type="text"
                class="form-control customInput p-3 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="myInput"
                onkeyup="myFunction()"
                placeholder="Chaap Platform"
              />
              <ul
                id="myUL"
                class="dropdown-menu w-100 height358 p-3 textDecorationNone"
                aria-labelledby="myInput"
              >
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">
                          Narela, New Delhi
                        </p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          5.0</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Noida Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">
                          Narela, New Delhi
                        </p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          5.0</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Noida Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </form>
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="row mt-4 justify-content-center">
            <ng-container *ngFor="let item of json6">
              <div
                *ngFor="let item of json6"
                class="col-md-4 col-6 col-lg-2 d-flex align-items-stretch mt-4"
              >
                <div
                  *ngIf="item.BizSpot"
                  class="card border-0 borderRadius10 cardShadow w-100"
                  (click)="GoToBizSpot(item.URL)"
                >
                  <div class="card-body">
                    <a>
                      <img
                        [src]="item.Logo"
                        class="img-fluid"
                        [alt]="item.BizSpot"
                      />
                    </a>
                    <p>{{ item.BizSpot }}</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
